// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Streaming animations */
@keyframes blink {
  0%,
  50% {
    opacity: 1;
  }

  51%,
  100% {
    opacity: 0;
  }
}

.streaming-cursor {
  animation: blink 1s infinite;
}

.streaming-text {
  position: relative;
}

/* Thinking dots animation */
.thinking-dots .animate-pulse {
  animation: pulse 1.5s ease-in-out infinite;
}

.thinking-dots .animate-pulse:nth-child(2) {
  animation-delay: 0.2s;
}

.thinking-dots .animate-pulse:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes pulse {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(0.8);
  }

  50% {
    opacity: 1;
    transform: scale(1);
  }
}

/* Smooth scrolling for chat container */
.scroller {
  scroll-behavior: smooth;
}

/* Typing effect for streaming text */
.streaming-text::after {
  content: '';
  display: inline-block;
  width: 2px;
  height: 1em;
  background-color: #3b82f6;
  margin-left: 2px;
  animation: blink 1s infinite;
  vertical-align: text-bottom;
}

/* Ensure links wrap properly in response container */
.response-span a {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  max-width: 100%;
}

.response-span ul,
.response-span li {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
}

.response-span {
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  font-family: 'DM Sans', ui-sans-serif, system-ui, sans-serif !important;
}

/* Inline SVG / icon markup from rehype-raw (e.g. AI returns <svg> or <img> icons) */
.response-span .prose svg,
.message-span .prose svg {
  display: inline-block;
  vertical-align: -0.15em;
  max-height: 1.35em;
  width: auto;
  flex-shrink: 0;
}

/* Ensure markdown/HTML images are visible (prose + nested scroll can confuse lazy-load) */
.response-span .prose img,
.message-span .prose img {
  display: inline-block;
  max-width: 100%;
  height: auto;
  vertical-align: middle;
}

/* Ordered lists: override prose-sm padding; native markers keep correct 1/2/3 sequencing */
.prose .chat-markdown-ol,
.chat-markdown-ol {
  list-style: decimal outside !important;
  list-style-type: decimal !important;
  list-style-position: outside !important;
  padding-inline-start: calc(var(--ol-marker-ch, 2) * 1ch + 0.35em) !important;
  margin-inline-start: 0;
  overflow: visible;
}

.chat-markdown-ol > li {
  display: list-item;
  padding-inline-start: 0.25em;
  overflow: visible;
}

.chat-markdown-ol > li::marker {
  font-variant-numeric: tabular-nums;
}

.response-span .prose,
.message-span .prose {
  overflow-x: visible;
}

.response-span .prose h1 {
  font-size: 1.125rem;
  font-weight: 600;
  margin-top: 1rem;
  margin-bottom: 0.5rem;
}

.response-span .prose h2 {
  font-size: 1.0625rem;
  font-weight: 600;
  margin-top: 0.875rem;
  margin-bottom: 0.375rem;
}

.response-span .prose h3 {
  font-size: 1rem;
  font-weight: 600;
  margin-top: 0.75rem;
  margin-bottom: 0.25rem;
}

.response-span .prose p {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

/* GFM tables from react-markdown + remark-gfm */
.response-span .prose table {
  display: table;
  width: 100%;
  font-size: 0.875rem;
}

.chat-markdown-table-scroll {
  scrollbar-width: thin;
  scrollbar-color: #c4c4c4 transparent;
}

.chat-markdown-table-scroll::-webkit-scrollbar {
  height: 8px;
}

.chat-markdown-table-scroll::-webkit-scrollbar-track {
  background: transparent;
}

.chat-markdown-table-scroll::-webkit-scrollbar-thumb {
  background-color: #c4c4c4;
  border-radius: 4px;
}

/* Font family for query container */
.message-container,
.message-span {
  font-family: 'DM Sans', ui-sans-serif, system-ui, sans-serif !important;
}

/* Focus border color for edit query textarea */
.edit-query-textarea:focus {
  border-color: #0a8bc7 !important;
  outline: none !important;
  box-shadow: 0 0 0 1px #0a8bc7 !important;
}

/* Hover effect for Cancel button in edit query */
.cancel-edit-button:hover {
  background-color: #f48b00 !important;
  color: white !important;
  border-color: #f48b00 !important;
}

/* Brain icon color on hover */
.brain-icon {
  transition: filter 0.2s ease-in-out;
}

.group:hover .brain-icon:not(.brain-icon-expanded) {
  filter: brightness(0) !important;
}

.brain-icon-expanded {
  filter: brightness(0) saturate(100%) invert(35%) sepia(96%) saturate(1352%) hue-rotate(182deg)
    brightness(95%) contrast(88%) !important;
}

/* Code block copy: wrapper is positioning context; button is NOT inside scrolling <pre> */
.chat-code-block-wrap {
  position: relative;
  width: 100%;
}

.chat-code-block-wrap .code-copy-btn {
  position: absolute;
  top: 6px;
  right: 8px;
  z-index: 20;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin: 0;
  padding: 2px 8px;
  min-height: 0;
  line-height: 1.2;
  cursor: pointer;
  border: 1px solid #d1d5db;
  border-radius: 6px;
  background: rgba(255, 255, 255, 0.96);
}

.chat-code-block-wrap .code-copy-btn:hover {
  background: #fff;
  border-color: #9ca3af;
}

.chat-code-block-wrap .code-copy-btn .code-copy-btn-label {
  color: #374151;
  font-size: 11px;
  margin-left: 2px;
}

.chat-code-block-wrap .code-copy-btn .code-copy-btn-label--ok {
  color: #059669;
}

/* Wrench icon color on hover */
.wrench-icon {
  transition: filter 0.2s ease-in-out;
}

.group:hover .wrench-icon:not(.wrench-icon-expanded) {
  filter: brightness(0) !important;
}

.wrench-icon-expanded {
  filter: brightness(0) saturate(100%) invert(58%) sepia(100%) saturate(1352%) hue-rotate(0deg)
    brightness(98%) contrast(96%) !important;
}

.response-version-nav-btn:focus-visible {
  outline: 2px solid #0a8bc7;
  outline-offset: 2px;
}
`, "",{"version":3,"sources":["webpack://./src/modules/end-user/chat/pages/chat-screen/content-container/content-container.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE;;IAEE,UAAU;EACZ;;EAEA;;IAEE,UAAU;EACZ;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;AACpB;;AAEA,4BAA4B;AAC5B;EACE,0CAA0C;AAC5C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,YAAY;IACZ,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;AAEA,wCAAwC;AACxC;EACE,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,WAAW;EACX,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,2BAA2B;AAC7B;;AAEA,qDAAqD;AACrD;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;EAEE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,uEAAuE;AACzE;;AAEA,oFAAoF;AACpF;;EAEE,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,cAAc;AAChB;;AAEA,0FAA0F;AAC1F;;EAEE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,sBAAsB;AACxB;;AAEA,2FAA2F;AAC3F;;EAEE,sCAAsC;EACtC,mCAAmC;EACnC,uCAAuC;EACvC,4EAA4E;EAC5E,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,gDAAgD;AAChD;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA,oCAAoC;AACpC;;EAEE,uEAAuE;AACzE;;AAEA,+CAA+C;AAC/C;EACE,gCAAgC;EAChC,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA,iDAAiD;AACjD;EACE,oCAAoC;EACpC,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA,8BAA8B;AAC9B;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;4CAC0C;AAC5C;;AAEA,0FAA0F;AAC1F;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,mCAAmC;AACrC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE;4CAC0C;AAC5C;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":["/* Streaming animations */\n@keyframes blink {\n  0%,\n  50% {\n    opacity: 1;\n  }\n\n  51%,\n  100% {\n    opacity: 0;\n  }\n}\n\n.streaming-cursor {\n  animation: blink 1s infinite;\n}\n\n.streaming-text {\n  position: relative;\n}\n\n/* Thinking dots animation */\n.thinking-dots .animate-pulse {\n  animation: pulse 1.5s ease-in-out infinite;\n}\n\n.thinking-dots .animate-pulse:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.thinking-dots .animate-pulse:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 0.4;\n    transform: scale(0.8);\n  }\n\n  50% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n/* Smooth scrolling for chat container */\n.scroller {\n  scroll-behavior: smooth;\n}\n\n/* Typing effect for streaming text */\n.streaming-text::after {\n  content: '';\n  display: inline-block;\n  width: 2px;\n  height: 1em;\n  background-color: #3b82f6;\n  margin-left: 2px;\n  animation: blink 1s infinite;\n  vertical-align: text-bottom;\n}\n\n/* Ensure links wrap properly in response container */\n.response-span a {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  max-width: 100%;\n}\n\n.response-span ul,\n.response-span li {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n}\n\n.response-span {\n  word-wrap: break-word;\n  overflow-wrap: break-word;\n  word-break: break-word;\n  font-family: 'DM Sans', ui-sans-serif, system-ui, sans-serif !important;\n}\n\n/* Inline SVG / icon markup from rehype-raw (e.g. AI returns <svg> or <img> icons) */\n.response-span .prose svg,\n.message-span .prose svg {\n  display: inline-block;\n  vertical-align: -0.15em;\n  max-height: 1.35em;\n  width: auto;\n  flex-shrink: 0;\n}\n\n/* Ensure markdown/HTML images are visible (prose + nested scroll can confuse lazy-load) */\n.response-span .prose img,\n.message-span .prose img {\n  display: inline-block;\n  max-width: 100%;\n  height: auto;\n  vertical-align: middle;\n}\n\n/* Ordered lists: override prose-sm padding; native markers keep correct 1/2/3 sequencing */\n.prose .chat-markdown-ol,\n.chat-markdown-ol {\n  list-style: decimal outside !important;\n  list-style-type: decimal !important;\n  list-style-position: outside !important;\n  padding-inline-start: calc(var(--ol-marker-ch, 2) * 1ch + 0.35em) !important;\n  margin-inline-start: 0;\n  overflow: visible;\n}\n\n.chat-markdown-ol > li {\n  display: list-item;\n  padding-inline-start: 0.25em;\n  overflow: visible;\n}\n\n.chat-markdown-ol > li::marker {\n  font-variant-numeric: tabular-nums;\n}\n\n.response-span .prose,\n.message-span .prose {\n  overflow-x: visible;\n}\n\n.response-span .prose h1 {\n  font-size: 1.125rem;\n  font-weight: 600;\n  margin-top: 1rem;\n  margin-bottom: 0.5rem;\n}\n\n.response-span .prose h2 {\n  font-size: 1.0625rem;\n  font-weight: 600;\n  margin-top: 0.875rem;\n  margin-bottom: 0.375rem;\n}\n\n.response-span .prose h3 {\n  font-size: 1rem;\n  font-weight: 600;\n  margin-top: 0.75rem;\n  margin-bottom: 0.25rem;\n}\n\n.response-span .prose p {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n/* GFM tables from react-markdown + remark-gfm */\n.response-span .prose table {\n  display: table;\n  width: 100%;\n  font-size: 0.875rem;\n}\n\n.chat-markdown-table-scroll {\n  scrollbar-width: thin;\n  scrollbar-color: #c4c4c4 transparent;\n}\n\n.chat-markdown-table-scroll::-webkit-scrollbar {\n  height: 8px;\n}\n\n.chat-markdown-table-scroll::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chat-markdown-table-scroll::-webkit-scrollbar-thumb {\n  background-color: #c4c4c4;\n  border-radius: 4px;\n}\n\n/* Font family for query container */\n.message-container,\n.message-span {\n  font-family: 'DM Sans', ui-sans-serif, system-ui, sans-serif !important;\n}\n\n/* Focus border color for edit query textarea */\n.edit-query-textarea:focus {\n  border-color: #0a8bc7 !important;\n  outline: none !important;\n  box-shadow: 0 0 0 1px #0a8bc7 !important;\n}\n\n/* Hover effect for Cancel button in edit query */\n.cancel-edit-button:hover {\n  background-color: #f48b00 !important;\n  color: white !important;\n  border-color: #f48b00 !important;\n}\n\n/* Brain icon color on hover */\n.brain-icon {\n  transition: filter 0.2s ease-in-out;\n}\n\n.group:hover .brain-icon:not(.brain-icon-expanded) {\n  filter: brightness(0) !important;\n}\n\n.brain-icon-expanded {\n  filter: brightness(0) saturate(100%) invert(35%) sepia(96%) saturate(1352%) hue-rotate(182deg)\n    brightness(95%) contrast(88%) !important;\n}\n\n/* Code block copy: wrapper is positioning context; button is NOT inside scrolling <pre> */\n.chat-code-block-wrap {\n  position: relative;\n  width: 100%;\n}\n\n.chat-code-block-wrap .code-copy-btn {\n  position: absolute;\n  top: 6px;\n  right: 8px;\n  z-index: 20;\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin: 0;\n  padding: 2px 8px;\n  min-height: 0;\n  line-height: 1.2;\n  cursor: pointer;\n  border: 1px solid #d1d5db;\n  border-radius: 6px;\n  background: rgba(255, 255, 255, 0.96);\n}\n\n.chat-code-block-wrap .code-copy-btn:hover {\n  background: #fff;\n  border-color: #9ca3af;\n}\n\n.chat-code-block-wrap .code-copy-btn .code-copy-btn-label {\n  color: #374151;\n  font-size: 11px;\n  margin-left: 2px;\n}\n\n.chat-code-block-wrap .code-copy-btn .code-copy-btn-label--ok {\n  color: #059669;\n}\n\n/* Wrench icon color on hover */\n.wrench-icon {\n  transition: filter 0.2s ease-in-out;\n}\n\n.group:hover .wrench-icon:not(.wrench-icon-expanded) {\n  filter: brightness(0) !important;\n}\n\n.wrench-icon-expanded {\n  filter: brightness(0) saturate(100%) invert(58%) sepia(100%) saturate(1352%) hue-rotate(0deg)\n    brightness(98%) contrast(96%) !important;\n}\n\n.response-version-nav-btn:focus-visible {\n  outline: 2px solid #0a8bc7;\n  outline-offset: 2px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
